import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectRequestCorrectionStatus = createSelector(
  [(store: RootState) => store.documentSignerShow.requestCorrectionStatus],
  (data) => data
);
